import { IOffer } from "@features/cart/ICart";

interface IUsageResponse {
    description: string;
    value: string;
    displayOrder: number;
}

export interface IOfferResponse {
    catalogTariffPlanCode: string;
    catalogOfferCode: string;
    description: string;
    displayOrder: number;
    recurringChargeAmount: number;
    upFrontChargeAmount: number;
    usages: IUsageResponse[];
}

export const getResponseToState = (response: IOfferResponse[]): IOffer[] =>
    response.map((offer) => ({
        catalogOfferCode: offer.catalogOfferCode,
        catalogTariffPlanCode: offer.catalogTariffPlanCode,
        description: offer.description,
        displayOrder: offer.displayOrder,
        recurringChargeAmount: offer.recurringChargeAmount,
        upFrontChargeAmount: offer.upFrontChargeAmount,
        usages: offer.usages.map((usage) => ({
            description: usage.description,
            value: usage.value,
            displayOrder: usage.displayOrder,
        })),
    }));
